export const TrustPilotRoutes = {
  REVIEW: 'review'
};
